import { useLingui } from '@lingui/react/macro'

export function Avatar({ url }: { url: string }) {
  const { t } = useLingui()

  return (
    <img
      src={url}
      alt={t`Your Avatar`}
      className="size-full rounded-full object-contain"
    />
  )
}
